module.exports = __webpack_public_path__ + "static/media/주식양수도.2875c795.png";